import { render, staticRenderFns } from "./OnlineTeaching.vue?vue&type=template&id=0e1cc2a8&scoped=true&"
import script from "./OnlineTeaching.vue?vue&type=script&lang=js&"
export * from "./OnlineTeaching.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTeaching.vue?vue&type=style&index=0&id=0e1cc2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1cc2a8",
  null
  
)

export default component.exports